import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.personnel',
    'resource:data.dimensions.personnel.entities.employee',
    'resource:data.dimensions.personnel.entities.employee.attributes.jobTitle',
    'resource:data.dimensions.personnel.entities.employee.attributes.resumeFile',
    'resource:data.dimensions.personnel.entities.employee.attributes.organization',
    'resource:data.enums.leaderType',
    'resource:data.enums.leaderType.entries.manager',
    'resource:data.enums.leaderType.entries.indirectManager',
    'resource:data.enums.leaderType.entries.other',
    'resource:data.dimensions.personnelLeaders',
    'resource:data.dimensions.personnelLeaders.entities.relationship',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.leader',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.leaderType',
    'resource:data.dimensions.personnelLeaders.entities.relationship.attributes.personnel',
    'resource:data.dimensions.employeeSkills',
    'resource:data.dimensions.employeeSkills.entities.entry',
    'resource:data.dimensions.employeeSkills.entities.entry.attributes.employee',
    'resource:data.dimensions.employeeSkills.entities.entry.attributes.skill',
    'resource:data.dimensions.projects',
    'resource:data.dimensions.projects.entities.project',
    'resource:data.dimensions.projects.entities.project.attributes.status',
    'resource:data.dimensions.skills',
    'resource:data.dimensions.skills.entities.skill',
    'resource:data.dimensions.skills.entities.skill.attributes.isCertificate',
    'resource:data.dimensions.engagements',
    'resource:data.dimensions.engagements.entities.engagement',
    'resource:data.dimensions.engagements.entities.engagement.attributes.employee',
    'resource:data.dimensions.engagements.entities.engagement.attributes.project',
    'resource:data.dimensions.engagements.entities.engagement.attributes.role',
    'resource:data.dimensions.engagements.entities.engagement.attributes.isCurrent',
    'resource:data.dimensions.engagements.entities.engagement.attributes.similarEmployee',
    'resource:data.dimensions.engagements.entities.engagement.attributes.proposedEmployee',
    'resource:data.dimensions.allocations',
    'resource:data.dimensions.allocations.entities.allocation',
    'resource:data.dimensions.allocations.entities.allocation.attributes.engagement',
    'resource:data.dimensions.allocations.entities.allocation.attributes.plannedWeeklyHours',
    'resource:data.dimensions.allocations.entities.allocation.attributes.actualWeeklyHours',
    'resource:data.dimensions.allocations.entities.allocation.attributes.isCurrent',
    'resource:data.dimensions.jobTitles',
    'resource:data.dimensions.jobTitles.entities.jobTitle',
    'resource:data.dimensions.organization',
    'resource:data.dimensions.organization.entities.division',
    'resource:data.dimensions.organization.entities.department',
    'resource:solutions.apps.employeePlanningAttainDigital',
    'resource:solutions.apps.employeePlanningAttainDigital.pages.employeeOrg',
    'resource:solutions.apps.employeePlanningAttainDigital.pages.engagements',
    'resource:solutions.apps.employeePlanningAttainDigital.pages.projects',
    'resource:solutions.mosaic.pages.employeePlanningAttainDigital.employeeOrg',
    'resource:solutions.mosaic.pages.employeePlanningAttainDigital.engagements',
    'resource:solutions.mosaic.pages.employeePlanningAttainDigital.projects',
    'resource:solutions.mosaic.widgets.employeePlanningAttainDigital.engagementsTable',
    'resource:solutions.mosaic.widgets.employeePlanningAttainDigital.projectsTable',
    'resource:solutions.mosaic.widgets.employeePlanningAttainDigital.orgEmployeeTree',
    'resource:solutions.agents.mosaic',
    'resource:solutions.agents.projectRecommendation',
  ],
  description:
    'Outlines employee profiles within an organization to inform project staffing decisions.',
  name: 'Employee Planning',
} as const satisfies core.quiver.Package
